const units = ['cero', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve'];
const teens = ['diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve'];
const tens = ['', 'diez', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];

function numberToSpanishWords(num) {
  if (num < 10) return units[num];
  if (num < 20) return teens[num - 10];
  if (num < 100) {
    const t = Math.floor(num / 10);
    const u = num % 10;
    if (t === 2 && u > 0) return 'veinti' + units[u];
    return tens[t] + (u > 0 ? ' y ' + units[u] : '');
  }
  if (num < 1000) {
    const h = Math.floor(num / 100);
    const r = num % 100;
    if (num === 100) return 'cien';
    const hWords = ['', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos'];
    return hWords[h] + (r > 0 ? ' ' + numberToSpanishWords(r) : '');
  }
  if (num < 1000000) {
    const k = Math.floor(num / 1000);
    const r = num % 1000;
    return (k === 1 ? 'mil' : numberToSpanishWords(k) + ' mil') + (r > 0 ? ' ' + numberToSpanishWords(r) : '');
  }
  return num.toString();
}

export const convertToSpanish = (num) => {
  const intPart = Math.floor(Math.abs(num));
  const decPart = Math.round((Math.abs(num) - intPart) * 100);
  let res = numberToSpanishWords(intPart);
  if (decPart > 0) res += ' con ' + numberToSpanishWords(decPart);
  return res;
};